/* Serrano safe quick-buy redirect + Daily Nuuds box-picker sizing. */
(function(){
'use strict';
var F='form.quick-buy-product-form, form[action*="/cart/add"][data-product-handle]';
function productPage(){return /\/products\//.test(location.pathname)}
function data(f){var i=f.closest('data-island');if(i&&window.Alpine)try{return window.Alpine.$data(i)||null}catch(e){}return null}
function multi(f){var d=data(f),p=d&&d.product,v=(p&&p.variants)||[];return !!(p&&p.has_only_default_variant===false&&v.length>1)}
function url(f){var d=data(f),p=d&&d.product;if(p&&p.url)return p.url;var h=(f.dataset&&f.dataset.productHandle)||(p&&p.handle),c=f.closest('li,.product-card,.product-tile,[class*="product"]')||f,a=c.querySelector('a[href*="/products/"]');return a?a.getAttribute('href'):(h?'/products/'+h:null)}
function redirect(f,e){if(!multi(f))return;var u=url(f);if(!u)return;e.preventDefault();e.stopImmediatePropagation();location.href=u}
document.addEventListener('submit',function(e){if(productPage())return;var f=e.target&&e.target.closest&&e.target.closest(F);if(f)redirect(f,e)},true);
document.addEventListener('click',function(e){if(productPage())return;var b=e.target&&e.target.closest&&e.target.closest('button[type="submit"],button[name="commit"],.push-btn,.product-card__quick-add-button,.quick-add__submit');if(!b)return;var f=b.closest(F);if(f)redirect(f,e)},true);
})();
(function(){
'use strict';
function style(){if(document.getElementById('serrano-box-builder-polish'))return;var s=document.createElement('style');s.id='serrano-box-builder-polish';s.textContent='.serrano-box-builder-wrapper,.serrano-box-builder{min-width:0!important;max-width:100%!important}.serrano-box-builder__grid{grid-template-columns:repeat(auto-fit,minmax(66px,1fr))!important;gap:8px!important;max-width:480px!important}.serrano-box-builder__image{width:54px!important;padding:3px!important;border-width:1.5px!important}.serrano-box-builder__name{font-size:10.5px!important;font-weight:600!important;line-height:1.15!important;min-height:auto!important;margin-top:5px!important}.serrano-box-builder__controls{grid-template-columns:24px minmax(20px,1fr) 24px!important;gap:3px!important;margin-top:5px!important}.serrano-box-builder__btn{width:24px!important;height:24px!important;min-width:24px!important;border-width:1px!important;border-radius:6px!important;font-size:14px!important;line-height:1!important}.serrano-box-builder__qty{font-size:13px!important}@media(max-width:749px){.serrano-box-builder__grid{display:flex!important;width:100%!important;max-width:calc(100vw - 28px)!important;gap:10px!important;overflow-x:auto!important;overflow-y:hidden!important;padding:4px 14px 10px 2px!important;scroll-snap-type:x proximity!important;overscroll-behavior-x:contain!important;-webkit-overflow-scrolling:touch!important;touch-action:pan-x pan-y!important;scrollbar-width:none!important;-ms-overflow-style:none!important}.serrano-box-builder__grid::-webkit-scrollbar{display:none!important}.serrano-box-builder__item{flex:0 0 72px!important;width:72px!important;min-width:72px!important;scroll-snap-align:start!important}.serrano-box-builder__image{width:50px!important}.serrano-box-builder__name{font-size:10px!important}.serrano-box-builder__controls{grid-template-columns:22px minmax(18px,1fr) 22px!important}.serrano-box-builder__btn{width:22px!important;height:22px!important;min-width:22px!important;font-size:13px!important}}';document.head.appendChild(s)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',style,{once:true});else style();
})();

/* SerranoMarkt — Daily Nuuds builder production core V2.1 — 2026-08-14 */
(function () {
  'use strict';
  if (window.__serranoHomeBuilderProductionV21) return;
  window.__serranoHomeBuilderProductionV21 = true;

  var BASE = 'https://cdn.shopify.com/s/files/1/0658/1865/6856/files/serrano-nuuds-box-base-1200.webp?v=1786703794';
  var SPRITES = {
    3: { url: 'https://cdn.shopify.com/s/files/1/0658/1865/6856/files/serrano-nuuds-box-sprite-3-gutter.webp?v=1786703867', frame: 800, cell: 808, offset: 4 },
    5: { url: 'https://cdn.shopify.com/s/files/1/0658/1865/6856/files/serrano-nuuds-box-sprite-5-gutter.webp?v=1786703884', frame: 800, cell: 808, offset: 4 }
  };
  var ROWS = {
    'Hot Cocoa': 0,
    'Pepper Red': 1,
    'Bare Black': 2,
    'Nuud Beige': 3,
    'Sky Blue': 4,
    'Balerina Pink': 5
  };
  var GIFT = {
    'Hot Cocoa': ['Hot Cocoa', 'Kahve'],
    'Pepper Red': ['Pepper Red', 'Kırmızı', 'Kirmizi'],
    'Bare Black': ['Bare Black', 'Siyah'],
    'Nuud Beige': ['Nuud Beige', 'Bej'],
    'Sky Blue': ['Sky Blue', 'Mavi'],
    'Balerina Pink': ['Balerina Pink', 'Pembe']
  };
  var PINK = 'Balerina Pink';
  var CACHE = new Map();

  function norm(value) {
    return String(value || '')
      .toLocaleLowerCase('tr-TR')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ı/g, 'i')
      .replace(/ş/g, 's')
      .replace(/ğ/g, 'g')
      .replace(/ü/g, 'u')
      .replace(/ö/g, 'o')
      .replace(/ç/g, 'c')
      .replace(/[’']/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function image(url) {
    if (CACHE.has(url)) return CACHE.get(url);
    var promise = new Promise(function (resolve, reject) {
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('Daily Nuuds kutu görseli yüklenemedi')); };
      img.src = url;
    });
    CACHE.set(url, promise);
    return promise;
  }

  function giftVariant(name) {
    var aliases = (GIFT[name] || [name]).map(norm);
    return (this.giftProduct && this.giftProduct.variants || []).find(function (variant) {
      return aliases.indexOf(norm(variant.title)) !== -1 && variant.available !== false;
    }) || null;
  }

  function canvasFor(builder) {
    if (!builder.box) return null;
    var canvas = builder.box.querySelector('canvas[data-serrano-home-box-canvas="v2"]');
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.width = 1600;
      canvas.height = 1600;
      canvas.dataset.serranoHomeBoxCanvas = 'v2';
      canvas.setAttribute('aria-hidden', 'true');
      Object.assign(canvas.style, {
        position: 'absolute',
        inset: '0',
        zIndex: '20',
        display: 'block',
        width: '100%',
        height: '100%',
        maxWidth: 'none',
        maxHeight: 'none',
        margin: '0',
        padding: '0',
        border: '0',
        background: 'transparent',
        pointerEvents: 'none',
        opacity: '0'
      });
      builder.box.appendChild(canvas);
    }
    return canvas;
  }

  async function renderBoxV2() {
    if (!this.box) return;
    var pack = Number(this.pack);
    if (pack !== 3 && pack !== 5) return;
    var sprite = SPRITES[pack];
    var canvas = canvasFor(this);
    if (!canvas) return;
    var rev = (this.__serranoBoxV2Rev || 0) + 1;
    this.__serranoBoxV2Rev = rev;

    try {
      var loaded = await Promise.all([image(BASE), image(sprite.url)]);
      if (this.__serranoBoxV2Rev !== rev || !canvas.isConnected) return;
      var buffer = document.createElement('canvas');
      buffer.width = 1600;
      buffer.height = 1600;
      var ctx = buffer.getContext('2d', { alpha: true });
      ctx.clearRect(0, 0, 1600, 1600);
      ctx.drawImage(loaded[0], 0, 0, 1600, 1600);

      for (var i = this.sequence.length - 1; i >= 0; i -= 1) {
        var color = this.sequence[i];
        var row = ROWS[color];
        if (!Number.isInteger(row)) continue;
        var sourceSlot = pack - i;
        var sx = (sourceSlot - 1) * sprite.cell + sprite.offset;
        var sy = row * sprite.cell + sprite.offset;
        if (pack === 3) {
          var pivotX = 834 / 2448 * 1600;
          var shiftY = -22 / 2448 * 1600;
          ctx.save();
          ctx.translate(pivotX, shiftY);
          ctx.scale(1.083, 1);
          ctx.translate(-pivotX, 0);
          ctx.drawImage(loaded[1], sx, sy, sprite.frame, sprite.frame, 0, 0, 1600, 1600);
          ctx.restore();
        } else {
          ctx.drawImage(loaded[1], sx, sy, sprite.frame, sprite.frame, 0, 0, 1600, 1600);
        }
      }

      var out = canvas.getContext('2d', { alpha: true });
      out.clearRect(0, 0, 1600, 1600);
      out.drawImage(buffer, 0, 0);
      this.box.classList.toggle('is-pack-3', pack === 3);
      this.box.classList.toggle('is-pack-5', pack === 5);
      this.box.style.setProperty('background', 'transparent', 'important');
      if (this.base) {
        this.base.style.setProperty('opacity', '0', 'important');
        this.base.style.setProperty('visibility', 'hidden', 'important');
      }
      var oldStack = this.box.querySelector('.dnhb__box-stack');
      if (oldStack) {
        oldStack.style.setProperty('display', 'none', 'important');
        oldStack.style.setProperty('visibility', 'hidden', 'important');
      }
      canvas.style.opacity = '1';
      canvas.dataset.pack = String(pack);
      canvas.dataset.selectedCount = String(this.sequence.length);
      canvas.dataset.selectionOrder = this.sequence.join('|');
      canvas.dataset.renderEngine = 'progressive-full-canvas-v2.1';
      this.box.dataset.serranoPerspective = 'v2.1';
    } catch (err) {
      console.error('[Serrano Home Box V2.1]', err);
      canvas.style.opacity = '0';
      if (this.base) {
        this.base.style.removeProperty('opacity');
        this.base.style.removeProperty('visibility');
      }
      var fallbackStack = this.box.querySelector('.dnhb__box-stack');
      if (fallbackStack) {
        fallbackStack.style.removeProperty('display');
        fallbackStack.style.removeProperty('visibility');
      }
    }
  }

  var PINK_CARD =
    '<article class="dnhb__color" data-color="Balerina Pink" data-slug="balerina-pink" data-value="#f4cbd8" data-cuts="Classic Bikini|Thong">' +
      '<button type="button" class="dnhb__color-image" data-add-color aria-label="Balerina Pink ekle">' +
        '<img src="https://cdn.shopify.com/s/files/1/0658/1865/6856/files/pembe_dekupe.png?v=1786438994" data-classic-image="https://cdn.shopify.com/s/files/1/0658/1865/6856/files/pembe_dekupe.png?v=1786438994" data-thong-image="https://cdn.shopify.com/s/files/1/0658/1865/6856/files/daily-nuuds-thong-pembe-3lu-2_97985556-d7af-4c8e-9899-317865664c93.png?v=1787574847" alt="Balerina Pink Daily Nuuds" loading="lazy" width="320" height="320">' +
        '<span aria-hidden="true">+</span>' +
      '</button>' +
      '<div class="dnhb__color-copy"><span class="dnhb__color-name"><strong>Balerina Pink</strong><small data-cut-label>CLASSIC BIKINI</small></span><i style="--swatch:#f4cbd8"></i></div>' +
      '<div class="dnhb__quantity">' +
        '<button type="button" data-minus aria-label="Balerina Pink azalt">−</button>' +
        '<strong data-color-count>0</strong>' +
        '<button type="button" data-plus aria-label="Balerina Pink artır">+</button>' +
      '</div>' +
    '</article>';

  function pinkCombinationAvailable(builder, pack) {
    return (builder.products && builder.products[String(pack)] && builder.products[String(pack)].variants || []).some(function (variant) {
      return norm(variant.title).indexOf(norm(PINK)) !== -1 && variant.available !== false;
    });
  }

  function ensurePink(builder) {
    if (!builder.colors || !pinkCombinationAvailable(builder, 3) || !pinkCombinationAvailable(builder, 5)) return;
    var card = builder.querySelector('.dnhb__color[data-color="' + PINK + '"]');
    if (!card) {
      var grid = builder.querySelector('.dnhb__color-grid');
      if (!grid) return;
      grid.insertAdjacentHTML('beforeend', PINK_CARD);
      card = grid.querySelector('.dnhb__color[data-color="' + PINK + '"]');
    }
    if (!card) return;
    if (!builder.colors[PINK]) {
      builder.colors[PINK] = { card: card, slug: 'balerina-pink', value: '#f4cbd8', cuts: ['Classic Bikini', 'Thong'], enabled: true, count: 0 };
      card.querySelector('[data-add-color]')?.addEventListener('click', function () { builder.changeColor(PINK, 1); });
      card.querySelector('[data-plus]')?.addEventListener('click', function () { builder.changeColor(PINK, 1); });
      card.querySelector('[data-minus]')?.addEventListener('click', function () { builder.changeColor(PINK, -1); });
    }
    builder.colorCards = Array.from(builder.querySelectorAll('.dnhb__color[data-color]'));
  }

  function patch(Constructor) {
    if (!Constructor || Constructor.prototype.__serranoBuilderProductionV21) return;
    Constructor.prototype.__serranoBuilderProductionV21 = true;
    Constructor.prototype.findGiftVariant = giftVariant;
    Constructor.prototype.renderBox = renderBoxV2;
  }

  function enhance(builder) {
    if (!builder || builder.dataset.serranoProductionV2 === 'true') return;
    patch(builder.constructor);
    ensurePink(builder);
    builder.dataset.serranoProductionV2 = 'true';
    builder.installGiftOptions && builder.installGiftOptions();
    builder.render && builder.render();
  }

  function boot() {
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('dn-home-box-builder').then(function () {
      patch(customElements.get('dn-home-box-builder'));
      document.querySelectorAll('dn-home-box-builder').forEach(enhance);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 0); });
})();
